import { render, staticRenderFns } from "./ViewContracts.vue?vue&type=template&id=1b960898"
import script from "./ViewContracts.vue?vue&type=script&lang=js"
export * from "./ViewContracts.vue?vue&type=script&lang=js"
import style0 from "./ViewContracts.vue?vue&type=style&index=0&id=1b960898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports